// @flow
import React from 'react'
import { Typography, Button } from '@material-ui/core/'
import i18n from 'i18next'

import Link from '../../../Link'
import CartIcon from '../CartIcon'
import styles from './styles'

type Props = {
  color: string,
  navigateTo: Function,
  total: number,
  viewport: string
}

const CartWithItems = (props: Props) =>
  props.viewport === 'xs' || props.viewport === 'sm' ? (
    <Link to={i18n.t('routes.CHECKOUT_REVIEW')} style={styles.cartMobile}>
      <CartIcon color={props.color} />
    </Link>
  ) : (
    <div style={styles.cart}>
      <Link to={i18n.t('routes.CHECKOUT_REVIEW')} style={styles.priceAndCart}>
        <CartIcon color={props.color} />
        <Typography variant='subtitle1' style={styles.price(props.color)}>
          <b>{`${props.total}`}</b>
        </Typography>
      </Link>
      <Button
        color='primary'
        style={styles.buyButton(props.color)}
        type='submit'
        onClick={() => props.navigateTo(i18n.t('routes.CHECKOUT_REVIEW'))}
        variant='contained'
      >
        <Typography
          variant='button'
          color='inherit'
          style={styles.buyButtonText}
        >
          {i18n.t('buyButton')}
        </Typography>
      </Button>
    </div>
  )

export default CartWithItems
